export default "__VITE_ASSET__CW6WGKmd__"